import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
import { WhatsAppLogo } from './icons/WhatsAppLogo';
export const CTASection = () => {
  return <section id="contact" className="py-16 bg-[#0a0a0a] relative border-t border-[#222]" data-id="element-106">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="flex flex-col lg:flex-row gap-6" data-id="element-108">
          {/* Left side - CTA content */}
          <div className="w-full lg:w-1/2" data-id="element-109">
            <div className="bg-[#0f0f0f] p-6 md:p-8 border border-[#222222] text-center lg:text-left relative h-full" data-id="element-110">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-111">
                Klaar voor een{' '}
                <span className="text-[#D6281F]" data-id="element-112">unieke look</span> voor jouw
                auto?
              </h2>
              <p className="text-[#CCCCCC] mb-6 text-base" data-id="element-113">
                Laat je auto transformeren door de experts van BKCustoms. Maak
                een afspraak of krijg advies van onze specialisten.
              </p>
              {/* Conversion Buttons */}
              <div className="flex flex-col gap-3 mb-6" data-id="element-114">
                {/* Afspraak maken button */}
                <Link to="/afspraak-maken" className="block bg-[#D6281F] hover:bg-[#C02218] px-4 py-3 group" data-id="element-115">
                  <div className="flex items-center justify-center lg:justify-start" data-id="element-116">
                    <CalendarIcon size={18} className="mr-2 text-white" data-id="element-117" />
                    <span className="text-white font-medium text-sm uppercase" data-id="element-118">
                      Afspraak maken
                    </span>
                  </div>
                </Link>
                {/* Advies krijgen button */}
                <Link to="/contact" className="block bg-[#1a1a1a] hover:bg-[#222] border border-[#333] px-4 py-3 transition-colors duration-300 group" data-id="element-119">
                  <div className="flex items-center justify-center lg:justify-start" data-id="element-120">
                    <span className="text-white font-medium text-sm uppercase" data-id="element-121">
                      Vraag ons advies
                    </span>
                  </div>
                </Link>
                {/* WhatsApp button */}
                <a href="https://wa.me/31627888306" target="_blank" rel="noopener noreferrer" className="block bg-[#1a1a1a] hover:bg-[#222] border border-[#333] px-4 py-3 transition-colors duration-300 group" data-id="element-122">
                  <div className="flex items-center justify-center lg:justify-start" data-id="element-123">
                    <WhatsAppLogo size={18} className="mr-2 text-[#25D366]" data-id="element-124" />
                    <span className="text-white font-medium text-sm uppercase" data-id="element-125">
                      WhatsApp
                    </span>
                  </div>
                </a>
              </div>
              {/* Address info */}
              <div className="flex items-start border-t border-[#222] pt-4" data-id="element-126">
                <MapPinIcon size={20} className="flex-shrink-0 text-[#D6281F] mr-2 mt-1" data-id="element-127" />
                <div data-id="element-128">
                  <h3 className="text-white font-medium text-base mb-1" data-id="element-129">
                    Bezoek onze werkplaats
                  </h3>
                  <p className="text-white/70 text-sm" data-id="element-130">
                    Microfoonstraat 36
                    <br data-id="element-131" />
                    1322 BN Almere
                    <br data-id="element-132" />
                    Ma-Za: 08:00-19:30 | Zo: Op afspraak
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Right side - Location image */}
          <div className="w-full lg:w-1/2" data-id="element-133">
            <div className="h-full border border-[#222]" data-id="element-134">
              <div className="relative h-full" data-id="element-135">
                {/* Image */}
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats ingang" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-136" />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70" data-id="element-137"></div>
                {/* Content overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-138">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-139">
                    Kom langs voor een persoonlijk advies
                  </h3>
                  <p className="text-white/80 mb-3 text-sm" data-id="element-140">
                    Ontdek wat wij voor jouw auto kunnen betekenen in onze
                    professionele werkplaats.
                  </p>
                  <a href="https://maps.google.com/?q=Microfoonstraat+36+1322+BN+Almere" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-[#1a1a1a] hover:bg-[#222] border border-[#333] px-3 py-1.5 text-white text-xs transition-colors duration-300" data-id="element-141">
                    <MapPinIcon size={14} className="mr-1.5" data-id="element-142" />
                    Route plannen
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};